import React from 'react';
import PropTypes from 'prop-types';
import {connect} from 'react-redux';
import {withRouter} from '@computerrock/formation-router';
import {useTranslate} from '@computerrock/formation-i18n';
import {useStyles, Panel, DataRow, InputCurrency, Icon, infoAlertIcon} from '@ace-de/ui-components';
import * as serviceAssignmentSelectors from '../../service-assignments/serviceAssignmentSelectors';
import config from '../../config';

const CostCoverageCostOverviewPanel = props => {
    const {cx} = useStyles();
    const {createTranslateShorthand, translate} = useTranslate();
    const translateTab = createTranslateShorthand('sarj_cost_coverage_tab');
    const {serviceCase, totalCost, onChangeHandler, hasCostError} = props;

    return (
        <Panel
            title={(
                <div
                    className={cx([
                        'global!ace-u-flex',
                        'global!ace-u-flex--align-center',
                    ])}
                >
                    <p>
                        {translateTab('panel_title.cost_overview', {
                            priceType: Number(serviceCase.commissioner.id) !== config.ACE_COMMISSIONER_ID
                                ? translate('global.pricing_type.net')
                                : translate('global.pricing_type.gross'),
                        })}
                    </p>
                    {hasCostError && (
                        <div
                            className={cx([
                                'global!ace-u-flex',
                                'global!ace-u-flex--align-center',
                                'global!ace-u-margin--left-8',
                                'global!ace-u-typography--variant-caption',
                                'global!ace-u-typography--color-warning',
                            ])}
                        >
                            <Icon
                                icon={infoAlertIcon}
                                className={cx([
                                    'global!ace-u-margin--right-4',
                                    'ace-c-icon--s',
                                    'ace-c-icon--color-warning',
                                    'global!ace-u-flex--shrink-0',
                                ])}
                            />
                            {translateTab('panel_error.zero_cost_not_allowed')}
                        </div>
                    )}
                </div>
            )}
            qaIdent="sarj-cost-coverage-cost-overview"
        >
            <div className={cx('global!ace-u-two-column-layout')}>
                <div>
                    <DataRow
                        label={translateTab('data_row_label.costs', {
                            priceType: Number(serviceCase.commissioner.id)
                            !== config.ACE_COMMISSIONER_ID
                                ? translate('global.pricing_type.net')
                                : translate('global.pricing_type.gross'),
                        })}
                        className={cx('ace-c-data-row--condensed')}
                        qaIdent="sa-total-cost"
                    >
                        <InputCurrency
                            className={cx('ace-c-input--small', 'global!ace-u-flex--grow-1')}
                            placeholder={translateTab('input_placeholder.please_enter_here')}
                            value={totalCost}
                            onChange={value => onChangeHandler('totalCost', value)}
                            min={0}
                            errors={hasCostError ? [''] : ''}
                        />
                    </DataRow>
                </div>
                <div>
                    <DataRow
                        label={translateTab('data_row_label.member_phone_no')}
                        qaIdent="sa-member-contact-details-phone"
                    >
                        {serviceCase.member.contactDetails.phoneNo || '-'}
                    </DataRow>
                </div>
            </div>
        </Panel>
    );
};

CostCoverageCostOverviewPanel.propTypes = {
    serviceCase: PropTypes.object,
    totalCost: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    onChangeHandler: PropTypes.func,
    hasCostError: PropTypes.bool,
};

CostCoverageCostOverviewPanel.defaultProps = {
    serviceCase: {},
    totalCost: '',
    onChangeHandler: null,
    hasCostError: false,
};

const mapStateToProps = (state, props) => {
    const serviceAssignmentSelector = serviceAssignmentSelectors.createServiceAssignmentSelector();
    return {
        serviceAssignment: serviceAssignmentSelector(state, props),
    };
};

export default withRouter(connect(mapStateToProps, null)(CostCoverageCostOverviewPanel));
